var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoBadgeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 32,
    viewBox: "0 0 116 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 32,
    rx: 12,
    fill: "#FB034F",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6694 8.76025C13.6964 8.53319 13.776 8.31556 13.9019 8.12467C14.0278 7.93377 14.1965 7.77487 14.3945 7.6606C14.5926 7.54632 14.8146 7.47983 15.0428 7.4664C15.2711 7.45298 15.4993 7.49299 15.7094 7.58325C16.7714 8.03725 19.1514 9.11625 22.1714 10.8593C25.1924 12.6033 27.3174 14.1263 28.2404 14.8173C29.0284 15.4083 29.0304 16.5803 28.2414 17.1733C27.3274 17.8603 25.2284 19.3633 22.1714 21.1293C19.1114 22.8953 16.7594 23.9613 15.7074 24.4093C14.8014 24.7963 13.7874 24.2093 13.6694 23.2323C13.5314 22.0903 13.2734 19.4973 13.2734 15.9953C13.2734 12.4953 13.5304 9.90325 13.6694 8.76025Z",
    fill: "#FB034F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoBadgeIcon);
export default __webpack_public_path__ + "static/media/video-badge-icon.a3e1a80b7f8b7834da85f9182954a1b9.svg";
export { ForwardRef as ReactComponent };